import { Component  } from '@angular/core';
import { NavController, NavParams,AlertController,LoadingController } from 'ionic-angular';
import { Http, Headers, RequestOptions,Response } from '@angular/http';
import { Storage } from '@ionic/storage';

//types
import { OrderDet,LoginInfo, OrderDetails } from '../model/types';

//service
import { AppSharedService  } from '../service/app_shared';

//page
import { MenuPage } from '../menu/menu'
import { LoginPage } from '../login/login'

@Component({
  selector: 'page-orderdetails',
  templateUrl: 'orderdetails.html',
})
export class OrderdetailsPage  {
 
//class variable
 orderId:number;
 orderList:OrderDet;
 imageUrlResources  : string;

 //constructor
  constructor(public navCtrl: NavController
    ,public navParams: NavParams
    ,private http: Http
    ,private storage: Storage
    ,public appSharedService:AppSharedService
    ,public alertCtrl: AlertController
    ,public loadingCtrl : LoadingController
  ) {

    //initialiaze class variable
    this.orderList={
      DeliverDate:'',
      OrderAddress:'',
      OrderAmount:0,
      OrderDate:'',
      OrderId:0,
      OrderStatus:0,
      CanCellable:false,
      OrderList:[],
      OrderNumber:'',
      OrderDiscount:''
    };
    
    this.orderId = navParams.data.orderId || 0;
    if(this.orderId==0){
      this.navCtrl.pop();
    }
    this.imageUrlResources= this.appSharedService.configInfo.applicationInfo.fileBasePath+'/Images/AppResources/';
    this.getOrderDetails();
  }

  goToHome(){
    this.navCtrl.popToRoot();
    this.navCtrl.setRoot(MenuPage)
  }
  //onclick delete button
  deleteorderdetails(ordObj:OrderDetails){ 
    
    if(this.orderList.CanCellable==true && ordObj.IsCancelled==0){       
      //var total= this.orderList.OrderAmount-ordObj.TotalAmount;    
      this.DeleteCurrentOrderDetails(ordObj.OrderDetailsId);
    }
  }

  //onclick cancel order button
  cancelorder(OrderId:number){

    if(this.orderList.CanCellable){
     this.CancelCurrentOrder(OrderId);
    }
    else
    {
      //show error message
      this.alertCtrl.create({
        title: 'Error in cancellation',
        subTitle: 'Your order can not be cancelled. Please contact bazaarhub support team.!',
        buttons: ['OK']
      }).present();

    }
  }
  
  // delete order details item
  DeleteCurrentOrderDetails(OrderDetailsId:number){

        //create loader
        let loading = this.loadingCtrl.create({
          content: 'Please wait...'
        });

    this.storage.get("bz_user_02").then((userinfo:LoginInfo) => {

      if(userinfo!=undefined && userinfo!=null && userinfo.Token!=undefined){
      
        //create header
      const headers = new Headers();
      headers.append('Content-Type', 'application/json');
      headers.append('token', userinfo.Token);
      const options = new RequestOptions({headers: headers});
     
      //create url
     var url=(this.appSharedService.configInfo.applicationInfo.apiBasePath+'/'+this.appSharedService.configInfo.urlInfo.urlDeleteOrderDetails);
    
     // show the loader
     loading.present();

     // do the service call
     this.http.get(url+"/"+OrderDetailsId,options )
         .subscribe((res: Response) => {   
              if(res.status==200){
                loading.dismiss();               
                let message=this.appSharedService.getHttpResponseText(res,'Please enter valid username and password!');

                //show success message
                this.alertCtrl.create({
                  title: 'Success',
                  subTitle: message,
                  buttons: ['OK']
                }).present();
               
                this.getOrderDetails();

              }else if(res.status==204){       
                loading.dismiss();
                this.storage.clear();
                this.navCtrl.popToRoot();
                this.navCtrl.setRoot(LoginPage)
              }
              
              else{        
              
                loading.dismiss();
              }
           });
          }
       });
  }

  //cancell current order
  CancelCurrentOrder(OrderId:number){
    
            //create loader
            let loading = this.loadingCtrl.create({
              content: 'Please wait...'
            });

    this.storage.get("bz_user_02").then((userinfo:LoginInfo) => {

      if(userinfo!=undefined && userinfo!=null && userinfo.Token!=undefined){
     
        //create header
      const headers = new Headers();
      headers.append('Content-Type', 'application/json');
      headers.append('token', userinfo.Token);
      const options = new RequestOptions({headers: headers});
     
      //create header
     var url=(this.appSharedService.configInfo.applicationInfo.apiBasePath+'/'+this.appSharedService.configInfo.urlInfo.urlCancelOrder);
     
     //show the loader
     loading.present();

     // do the service error
     this.http.get(url+"/"+OrderId,options )
         .subscribe((res: Response) => {   
              if(res.status==200){
                // dismiss the loader
                loading.dismiss();
                let message=this.appSharedService.getHttpResponseText(res,'Your order cancelled successfully.!');

                // show sucess message
                this.alertCtrl.create({
                  title: 'Success',
                  subTitle: message,
                  buttons: ['OK']
                }).present();
                
                //refresh details
                this.getOrderDetails();

              }else{    

                // dismiss the loader
                loading.dismiss();
              }
           });
          }
       });
  }

  // get order details 
  getOrderDetails(){
   
                //create loader
                let loading = this.loadingCtrl.create({
                  content: 'Please wait...'
                });

    this.storage.get("bz_user_02").then((userinfo:LoginInfo) => {

      if(userinfo!=undefined && userinfo!=null && userinfo.Token!=undefined){

        //create headers
      const headers = new Headers();
      headers.append('Content-Type', 'application/json');
      headers.append('token', userinfo.Token);
      const options = new RequestOptions({headers: headers});
      
      //show the loader
      loading.present();
      // create url
     var url=(this.appSharedService.configInfo.applicationInfo.apiBasePath+'/'+this.appSharedService.configInfo.urlInfo.urlGetOrderDetails);
     
     // do the service call
     this.http.get(url+"/"+this.orderId,options )
         .subscribe((res: Response) => {   
              if(res.status==200){
                
                this.orderList= JSON.parse(res.text()) as OrderDet;
                // dismiss the loader
                loading.dismiss();

              }else{ 
                       
                // dismiss the loader
                loading.dismiss();
              }
           });
          }
       });
    }
}



// WEBPACK FOOTER //
// ./src/pages/orderdetails/orderdetails.ts